module.exports = __webpack_public_path__ + "img/logo.c2c9c610.png";